import { MijnRoute } from '../../mijn-navigatie.model';

export const PAYMENT_REQUEST_FORM: MijnRoute = {
    path: 'betaalverzoek/betaalverzoek-aanmaken',
    navigationEvent: 'toNewBetaalverzoek',
    regex: /^\/betaalverzoek\/betaalverzoek-aanmaken$/,
    webcomponent: 'mijn-betalen-betaalverzoek-webcomponent',
    internalPath: 'betaalverzoek-aanmaken'
};
